import React, { useState } from "react";
import LocationPinIcon from "../Icons/LocationPinIcon";

const SuggestionDiv = ({
  suggestions = [],
  getSuggestionItemProps = () => ({}),
  loading = false,
  iconNode = null,
  iconStyle = {},
  // optional controlled highlightedIndex (used for keyboard nav)
  highlightedIndex = null,
  // optional callback fired when mouse hovers a suggestion
  onHoverChange = () => {},
  // optional CSS class names passed from callers
  containerClassName = "w-full my-2",
  lineClassName = "",
}) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  return (
    <div className={containerClassName}>
      {/* Dotted loading animation */}
      {loading ? (
        <div className="flex items-center justify-center space-x-1">
          <span className="w-2 h-2 bg-[#4743BF] rounded-full animate-bounce"></span>
          <span className="w-2 h-2 bg-[#4743BF] rounded-full animate-bounce [animation-delay:0.15s]"></span>
          <span className="w-2 h-2 bg-[#4743BF] rounded-full animate-bounce [animation-delay:0.3s]"></span>
        </div>
      ) : null}

      {suggestions.map((suggestion, idx) => {
        // prefer externally-controlled highlightedIndex when provided
        const isHovered =
          highlightedIndex != null ? highlightedIndex === idx : hoveredIndex === idx;
        const isLast = idx === suggestions.length - 1;

        const baseStyle = {
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "8px 6px",
          width: "100%",
          backgroundColor: isHovered ? "#34318C" : "transparent",
          cursor: "pointer",
          color: isHovered ? "white" : "#211F59",
          borderRadius: 10,
          marginBottom: isLast ? "2.5rem" : "0px", // mb-10 for the last item only
        };

        const propsFromGet = getSuggestionItemProps(suggestion, {
          style: baseStyle,
        });

        const mergedProps = {
          ...propsFromGet,
          onMouseEnter: (e) => {
            setHoveredIndex(idx);
            try {
              onHoverChange(idx);
            } catch (err) {}
            if (typeof propsFromGet.onMouseEnter === "function")
              propsFromGet.onMouseEnter(e);
          },
          onMouseLeave: (e) => {
            setHoveredIndex(null);
            try {
              onHoverChange(null);
            } catch (err) {}
            if (typeof propsFromGet.onMouseLeave === "function")
              propsFromGet.onMouseLeave(e);
          },
        };

        const iconWrapperStyle = {
          width: 20,
          minWidth: 20,
          height: 20,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flex: "0 0 auto",
        };

        const textStyle = {
          fontSize: 14,
          flex: 1,
          wordBreak: "break-word",
          whiteSpace: "normal",
        };

        return (
          <div key={idx} {...mergedProps} style={baseStyle} className={lineClassName}>
            <div style={iconWrapperStyle}>
              {iconNode ? (
                iconNode
              ) : (
                <LocationPinIcon
                  width={14}
                  height={17}
                  style={{
                    color: isHovered ? "#fff" : "#7876A1",
                    display: "block",
                    ...iconStyle,
                  }}
                />
              )}
            </div>

            <div style={textStyle}>{suggestion?.description}</div>
          </div>
        );
      })}
    </div>
  );
};

export default SuggestionDiv;

